import React from "react";
import { connect } from "react-redux";
import { fetchalertprofiles } from "./Reducers/actions";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
class AlertProfilePage extends React.Component {
  state = {
    errors: {},
    deelnemers: 0,
    hulpkrachten: 0,
    recreatieleider: 0,
    stagiaires: 0
  };

  componentWillMount() {
    this.props.fetchalertprofiles().then(data => {});
  
  }


  handleItem(item) {}

  render() {
    const columns = [
      {
        dataField: "naam",
        text: "Naam"
      },
      {
        dataField: "interval",
        text: "Interval"
      },
      {
        text: "Acties",
        dataField: "_id",
        formatter: (cellContent, row) => {
          return (
          <span>
            <Link className="btn btn-sm btn-warning" to={"/sensoren/alertprofile/edit/"+row._id }>Wijzigen</Link>

            </span>
          )
        },
        headerStyle: (colum, colIndex) => {
         return { width: '250px' };
       }
      }
    ];
    const { alertprofile } = this.props;
    return (
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title"> Overzicht Alert Pofiles</h3>
          <div className="box-tools pull-right">
            <Link
              type="button"
              className="btn-primary btn btn-box-too btn-sm"
              to="/sensoren/alertprofile/insert"
            >
              <i className="fa fa-plus"></i>&nbsp; Alert Profile Toevoegen
            </Link>
          </div>
        </div>
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile" />
            <BootstrapTable
              wrapperClasses="table-responsive-md"
              keyField="_id"
              data={alertprofile}
              columns={columns}
              pagination={paginationFactory()}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { username: state.auth.user, alertprofile: state.alertprofile.items };
}

export default connect(mapStateToProps, { fetchalertprofiles })(AlertProfilePage);
